import { render, staticRenderFns } from "./VendorBasicDetails.vue?vue&type=template&id=0a062ed6&"
import script from "./VendorBasicDetails.vue?vue&type=script&lang=js&"
export * from "./VendorBasicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports